import { COLS, Grid, Match, ROWS, TileKind } from './types';

export function findMatches(grid: Grid): Match[] {
  const matches: Match[] = [];

  for (let r = 0; r < ROWS; r++) {
    let runKind: TileKind | null = null;
    let runStart = 0;
    for (let c = 0; c <= COLS; c++) {
      const tile = c < COLS ? grid[r][c] : null;
      const kind = tile ? tile.kind : null;
      if (kind !== runKind) {
        if (runKind !== null && c - runStart >= 3) {
          matches.push({
            kind: runKind,
            cells: rangeCells(r, runStart, c - 1, 'row'),
          });
        }
        runKind = kind;
        runStart = c;
      }
    }
  }

  for (let c = 0; c < COLS; c++) {
    let runKind: TileKind | null = null;
    let runStart = 0;
    for (let r = 0; r <= ROWS; r++) {
      const tile = r < ROWS ? grid[r][c] : null;
      const kind = tile ? tile.kind : null;
      if (kind !== runKind) {
        if (runKind !== null && r - runStart >= 3) {
          matches.push({
            kind: runKind,
            cells: rangeCells(c, runStart, r - 1, 'col'),
          });
        }
        runKind = kind;
        runStart = r;
      }
    }
  }

  return matches;
}

function rangeCells(fixed: number, start: number, end: number, axis: 'row' | 'col') {
  const cells = [];
  for (let i = start; i <= end; i++) {
    cells.push(axis === 'row' ? { row: fixed, col: i } : { row: i, col: fixed });
  }
  return cells;
}

export function matchesAnywhere(grid: Grid): boolean {
  return findMatches(grid).length > 0;
}
